module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('span', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THIS BOOK IS DEDICATED TO GENERAL ARIK SHARON")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE DIVISION COMMANDER")]), _vm._v(". "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TO KUTI MOTKE YAAKOV AND URI")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITS SENIOR OFFICERS")]), _vm._v(". "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TO THE OFFICERS AND SOLDIERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF THE DIVISION")]), _vm._v("—"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THOSE ALIVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND THOSE WHO DIED ENABLING ITS VICTORY")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', [_c('i', [_vm._v("The division suffered 240 casualties. Of those 58 dead")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cb6c9d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0